// src/App.js
import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './HomePage';
import Services from './Services'; // Import the Services component
import Sectors from './Sectors'; 
import ChinaFocus from './ChinaFocus'; 
import IndiaFocus from './IndiaFocus'; 
import Technology from './Technology';
import CoreValues from './CoreValues';
import Resources from './Resources';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import ContactUs from './ContactUs';
function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<Services />} />
          <Route path="/sectors" element={<Sectors />} />
          <Route path="/chinaFocus" element={<ChinaFocus />} />
          <Route path="/indiaFocus" element={<IndiaFocus />} />
          <Route path="/technology" element={<Technology />} />
          <Route path="/coreValues" element={<CoreValues />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/TermsOfService" element={<TermsOfService />} />
          <Route path="/ContactUs" element={<ContactUs />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
